import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse } from 'react-router-dom';

import { Curtain, CurtainProps } from '../components/Curtain';

export interface ErrorCurtainProps extends Omit<CurtainProps, 'act'> {
  error?: unknown;
}

export const ErrorCurtain: FC<ErrorCurtainProps> = ({ error, ...rest }) => {
  const { t } = useTranslation();

  const [title, text] = useMemo((): [
    string | undefined,
    string | undefined
  ] => {
    if (isRouteErrorResponse(error)) {
      switch (error.status) {
        case 404:
          return [undefined, t('Error.status.404.text')];
      }
    }

    return [undefined, undefined];
  }, [error, t]);

  return <Curtain act="error" title={title} text={text} {...rest} />;
};
